// List of common public email domains
const publicDomains = [
  "gmail.com",
  "hotmail.com",
  "yahoo.com",
  "outlook.com",
  "aol.com",
  "icloud.com",
  "mail.com",
  "zoho.com",
  "gmx.com",
  "protonmail.com",
  "abc.com",
  "xyz.com",
];

export const validateForPersonalEmail = (email = "") => {
  // Extract domain from email
  const emailDomain = email.split("@")[1] || "";

  // Check if the email domain is in the list of public domains
  return publicDomains.includes(emailDomain.toLowerCase());
};
